import { render, staticRenderFns } from "./ProducerStorageAddresses.vue?vue&type=template&id=5c03b8f7&scoped=true"
import script from "./ProducerStorageAddresses.vue?vue&type=script&lang=js"
export * from "./ProducerStorageAddresses.vue?vue&type=script&lang=js"
import style0 from "./ProducerStorageAddresses.vue?vue&type=style&index=0&id=5c03b8f7&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c03b8f7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c03b8f7')) {
      api.createRecord('5c03b8f7', component.options)
    } else {
      api.reload('5c03b8f7', component.options)
    }
    module.hot.accept("./ProducerStorageAddresses.vue?vue&type=template&id=5c03b8f7&scoped=true", function () {
      api.rerender('5c03b8f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/producers/ProducerStorageAddresses.vue"
export default component.exports